<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Histórico de Eventos do Sistema</h2>
                    </div>
                </div>

                <div class="panel-body" (window:resize)="onResize($event)">
                    <form [formGroup]="formularioDeConsultaDeHistoricoDeEventos" (ngSubmit)="onSubmit()">
                        <div class="form-row form-row-filtro">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-7 col-12">
                                <mat-label>Login</mat-label>
                                <input matInput value="Login" class="form-control" id="usuario" trim="blur" name="nome"
                                    formControlName="usuario" maxlength="30" upperCase>

                                <mat-error
                                    *ngIf="formularioDeConsultaDeHistoricoDeEventos.controls.usuario.hasError('minlength')">
                                    O campo Nome precisa conter mais do que 2 caracteres.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-5 col-12">
                                <mat-label>Data Evento Inicial e Final</mat-label>

                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="Data Inicial" formControlName="dataEventoInicial">
                                    <input matEndDate placeholder="Data Final" formControlName="dataEventoFinal">
                                </mat-date-range-input>

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <mat-error
                                    *ngIf="formularioDeConsultaDeHistoricoDeEventos.controls.dataEventoInicial.hasError('invalidDate') || formularioDeConsultaDeHistoricoDeEventos.controls.dataEventoFinal.hasError('invalidDate')">
                                    Datas inválidas ou com intervalos não permitidos.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row form-row-filtro">
                            <mat-form-field class="form-group col-lg-5 col-md-5 col-sm-6 col-12">
                                <mat-label>Menu</mat-label>
                                <mat-select value="Menu" formControlName="menu" name="menu" id="menu">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let menu of listaMenusSistema" [value]="menu.codigo">
                                        {{menu.descricao}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="form-group col-lg-5 col-md-5 col-sm-6 col-12">
                                <mat-label>Evento</mat-label>
                                <mat-select value="Evento" formControlName="evento" name="evento" id="evento">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let evento of listaEventosSistema" [value]="evento.codigo">
                                        {{evento.descricao}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="form-group col-lg-2 col-md-2 col-sm-12 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeConsultaDeHistoricoDeEventos.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="form-row form-row-filtro">
                        <div class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-form-field fxFlex="100%">
                                <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </div>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="data">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Evento </th>
                            <td mat-cell *matCellDef="let historicoEvento"> {{historicoEvento.data | date:"dd/MM/yyyy"}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="usuario">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </th>
                            <td mat-cell *matCellDef="let historicoEvento"> {{historicoEvento.usuario}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="menuFormatado">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Menu </th>
                            <td mat-cell *matCellDef="let historicoEvento"> {{historicoEvento.menuFormatado}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="eventoFormatado">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Evento </th>
                            <td mat-cell *matCellDef="let historicoEvento"> {{historicoEvento.eventoFormatado}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="complemento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Complemento </th>
                            <td mat-cell *matCellDef="let historicoEvento"> {{historicoEvento.complemento}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 30, 50, 70, 100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>